import type { ICategoryCollection } from '@/assets/types/api/Categories';

export const useCategoryStore = defineStore('categoryStore', () => {
  const nuxtApp = useNuxtApp();

  /* State */

  const collections = ref<ICategoryCollection[]>([]);

  /* Actions */

  const USE_GET_PRODUCTS = async () => {
    /**
     * 取得指定類別的產品清單
     *
     * 注意：依規格 categoryCode 限制只能是 Type = 1 的分類，
     *       因此 [generic] 路由也只用 subcategory 呼叫 API。
     */
    const { $i18n, $notification } = nuxtApp;
    const { locale } = $i18n;

    const route = useRoute();
    const { subcategory } = route.params;

    const categoryCode = computed(() => subcategory);

    return await useCustomFetch(
      () =>
        `/marketplace/api/v1/product-categories/${categoryCode.value}?websiteCode=${locale.value}`,
      {
        method: 'GET',
        lazy: true,
        immediate: true,
        onResponse: ({ response }) => {
          const { _data, status } = response;

          if (status >= 200 && status < 300) {
            collections.value = [...(_data as ICategoryCollection[])];
          } else {
            console.error(_data);
            $notification({
              message: (_data as { message: string }).message,
              type: 'error',
            });
          }
        },
      }
    );
  };

  return {
    collections,
    USE_GET_PRODUCTS,
  };
});
